export default __webpack_public_path__ + "static/media/ico-foot-mail.ef999ec3.svg";